<template>
  <v-snackbar color="#e21b23" :value="error.show">
    {{
    error.text
    }}
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SnackBarNotification",
  computed: {
    ...mapState({
      error: state => state.error
    })
  }
};
</script>
